import './design-tokens.css'
import './index.css'
import './animations.css'
import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import { AuthProvider } from './contexts/AuthContext.jsx'
import { SelectedStoreProvider } from './contexts/SelectedStoreContext.jsx'
import ToastProvider from './contexts/ToastProvider.jsx'
import { registerServiceWorker } from './utils/registerServiceWorker.js'
import { applyResolvedPalette } from './utils/paletteExplorer.js'
import { GuestKitchenProvider } from './contexts/GuestKitchenContext.jsx'

applyResolvedPalette()

// Build version - changes on each deployment to force bundle hash update
// This ensures browsers fetch new bundles even if code changes are minimal
// Updated: 2026-04-05 - Trigger production frontend deploy
const BUILD_VERSION = '20260405-trigger-deploy'

// Export build version (this ensures it's included in the bundle)
export const getBuildVersion = () => BUILD_VERSION

// Force bundle hash change by including version in module scope and using it
if (typeof window !== 'undefined') {
  window.__BUILD_VERSION__ = BUILD_VERSION
  // Use the version in a way that affects the bundle
  if (import.meta.env.DEV) {
    console.log('Build version:', BUILD_VERSION)
  }
  // Debug: ?showOnboarding=1 — capture before React/effects so Shop (and other tabs) still see it after
  // ?tab= sync or when GrocerySearch mounts only on the Shop tab.
  try {
    const p = new URLSearchParams(window.location.search)
    if (p.get('showOnboarding') === '1' || p.get('showOnboarding') === 'true') {
      sessionStorage.setItem('debug_show_onboarding', '1')
    }
  } catch {
    // ignore
  }
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <AuthProvider>
    <GuestKitchenProvider>
      <SelectedStoreProvider>
        <ToastProvider>
          <App />
        </ToastProvider>
      </SelectedStoreProvider>
    </GuestKitchenProvider>
  </AuthProvider>
)

registerServiceWorker()
